import React, { useEffect, useRef, useState } from 'react'
import { LuTriangleAlert, LuX } from 'react-icons/lu'
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import { PhoneNumberUtil } from 'google-libphonenumber';
import { toast } from 'react-toastify';
import nameIcon from "../../images/forms/name.svg";
import emailIcon from "../../images/forms/email.svg";
import phoneIcon from "../../images/forms/phone.svg";
import yearIcon from "../../images/forms/year.svg";
import graduationIcon from "../../images/forms/graduation.svg";
import collegeIcon from "../../images/forms/college.svg";
import universityIcon from "../../images/forms/university.svg";
import locationIcon from "../../images/forms/location.svg";
import domainYearsIcon from "../../images/forms/degree.svg";
import teachingIcon from "../../images/forms/department.svg";
import interestIcon from "../../images/forms/interested.svg";
import experienceIcon from "../../images/forms/experience.svg";
import daysIcon from "../../images/forms/aim.svg";
import engagementIcon from "../../images/forms/challenge.svg";
import sessionIcon from "../../images/forms/session.svg";
import consentIcon from "../../images/forms/consent.svg";
import axios from 'axios';
import API from '../../../utils/API';
import LoadLottie from '../loadLottie';
import Tick from "../../../json/tick-mark.json";
import Error from "../../../json/error.json";
import { FaLinkedin } from "react-icons/fa6";
import { MdAutoFixHigh, MdVideocam, MdVolunteerActivism } from 'react-icons/md';
import { GoClockFill } from 'react-icons/go';

export default function SurgeSpeakerForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");
    const [location, setLocation] = useState("");

    const [linkedin, setLinkdin] = useState("");
    const [role, setRole] = useState("");
    const [company, setCompany] = useState("");
    const [years, setYears] = useState("");

    const [domainYears, setDomainYears] = useState("");
    const [teaching, setTeaching] = useState("");
    const [interestedTrack, setInterestedTrack] = useState("");
    const [experience, setExperience] = useState("");

    const [tools, setTools] = useState("");
    const [days, setDays] = useState("");
    const [time, setTime] = useState("");
    const [engagement, setEngagement] = useState("");
    const [session, setSession] = useState("");


    const [volunteer, setVolunteer] = useState("");
    const [consent, setConsent] = useState("");
    const [record, setRecord] = useState("");
    const [bio, setBio] = useState("");

    const [nameError, setNameError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [numberError, setNumberError] = useState("");
    const [locationError, setLocationError] = useState("");

    const [linkdinError, setLinkdinError] = useState("");
    const [roleError, setRoleError] = useState("");
    const [companyError, setCompanyError] = useState("");
    const [yearsError, setYearsError] = useState("");

    const [domainYearsError, setDomainYearsError] = useState("");
    const [teachingError, setTeachingError] = useState("");
    const [interestedTrackError, setInterestedTrackError] = useState("");
    const [experienceError, setExperienceError] = useState("");

    const [toolsError, setToolsError] = useState("");
    const [daysError, setDaysError] = useState("");
    const [timeError, setTimeError] = useState("");
    const [engagementError, setEngagementError] = useState("");
    const [sessionError, setSessionError] = useState("");

    const [volunteerError, setVolunteerError] = useState("");
    const [consentError, setConsentError] = useState("");
    const [recordError, setRecordError] = useState("");
    const [bioError, setBioError] = useState("");



    const [countryCode, setCountryCode] = useState({});

    const [isStep1, setIsStep1] = useState(false);
    const [isStep2, setIsStep2] = useState(false);
    const [isStep3, setIsStep3] = useState(false);
    const [isStep4, setIsStep4] = useState(false);

    const [isClicked, setIsClicked] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isPaymentFailed, setIsPaymentFailed] = useState(false);
    const [timeLeft, setTimeLeft] = useState(30);
    const timerRef = useRef(null);

    const [scriptLoaded, setScriptLoaded] = useState(false);

    const invalidCharsRegex = /^[\s\u200B-\u200D\uFEFF]+$/;
    const linkedinRegex = /^(https?:\/\/)?(www\.)?linkedin\.com\/(in|company)\/[A-Za-z0-9\-_%]+\/?$/i;


    const handleStep1 = async () => {
        try {
            const phoneUtil = PhoneNumberUtil.getInstance();
            const phoneWithoutPlus = number.startsWith(`+${countryCode?.dialCode}`)
                ? number.slice(countryCode?.dialCode?.length + 1)
                : number;

            // --- Regex Helpers ---
            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-z]{2,}$/i;

            // --- Name Validation ---
            if (!name.trim()) return setNameError("Please fill in this");
            if (invalidCharsRegex.test(name)) return setNameError("Invalid special characters");

            // --- Email Validation ---
            if (!email) return setEmailError("Please fill in this");
            if (invalidCharsRegex.test(email)) return setEmailError("Invalid special characters");
            if (!emailRegex.test(email)) return setEmailError("Hmm... that email doesn't look right");

            // --- Phone Validation ---
            let isValid = false;
            try {
                const parsedPhone = phoneUtil.parse(number, countryCode?.iso2);
                isValid = phoneUtil.isValidNumber(parsedPhone);
            } catch {
                isValid = false;
            }
            if (!isValid || !phoneWithoutPlus) {
                return setNumberError("Hmm... that number doesn't look right");
            }

            // --- Linkedin Validation ---
            if (!location.trim()) return setLocationError("Please fill in this");
            if (invalidCharsRegex.test(location)) return setLocationError("Invalid special characters");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SPEAKER_SUBMIT, {
                email,
                name,
                phone: number,
                cityCountry: location,
            });

            if (data?.statusCode === 200) {
                setIsStep1(true)
            }
            setIsStep1(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep2 = async () => {
        try {

            // --- Linkedin Validation ---
            if (!linkedin.trim()) {
                setLinkdinError("Please fill in this");
                return;
            }

            if (!linkedinRegex.test(linkedin.trim())) {
                setLinkdinError("Invalid LinkedIn URL");
                return;
            }

            // --- Graduation year Validation ---
            if (!role.trim()) return setRoleError("Please fill in this");
            if (invalidCharsRegex.test(role)) return setRoleError("Invalid special characters");

            // --- College name Validation ---
            if (!company.trim()) return setCompanyError("Please fill in this");
            if (invalidCharsRegex.test(company)) return setCompanyError("Invalid special characters");

            // --- University name Validation ---
            if (!years.trim()) return setYearsError("Please fill in this");
            if (invalidCharsRegex.test(years)) return setYearsError("Invalid special characters");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SPEAKER_SUBMIT, {
                email,
                linkedinUrl: linkedin,
                currentRole: role,
                currentCompany: company,
                totalExperience: years,
            });

            if (data?.statusCode === 200) {
                setIsStep2(true)
            }
            setIsStep2(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep3 = async () => {
        try {

            // --- domainYears Validation ---
            if (!domainYears.trim()) return setDomainYearsError("Please fill in this");
            if (invalidCharsRegex.test(domainYears)) return setDomainYearsError("Invalid special characters");

            // --- Departmenr name Validation ---
            if (!teaching.trim()) return setTeachingError("Please fill in this");
            if (invalidCharsRegex.test(teaching)) return setTeachingError("Invalid special characters");

            // --- Interested track Validation ---
            if (!interestedTrack.trim()) return setInterestedTrackError("Please Select atleast one option...");

            // --- Experience Validation ---
            if (!experience.trim()) return setExperienceError("Please Select atleast one option...");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SPEAKER_SUBMIT, {
                email,
                relevantExperience: domainYears,
                hasMentoringExperience: teaching === "No" ? false : true,
                primaryDomain: interestedTrack,
                expertiseLevel: experience
            });

            if (data?.statusCode === 200) {
                setIsStep3(true)
            }
            setIsStep3(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep4 = async () => {
        try {

            // --- Tools Validation ---
            if (!tools.trim()) return setToolsError("Please fill in this");
            if (invalidCharsRegex.test(tools)) return setToolsError("Invalid special characters");

            // --- days Validation ---
            if (!days.trim()) return setDaysError("Please Select atleast one option...");

            // --- Time Validation ---
            if (!time.trim()) return setTimeError("Please Select atleast one option...");

            // --- engagement name Validation ---
            if (!engagement.trim()) return setEngagementError("Please Select atleast one option...");

            // --- Session Validation ---
            if (!session.trim()) return setSessionError("Please Select atleast one option...");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SPEAKER_SUBMIT, {
                email,
                tools,
                preferredDays: days,
                preferredTiming: time,
                frequency: engagement,
                duration: session,
            });

            if (data?.statusCode === 200) {
                setIsStep4(true)
            }
            setIsStep4(true)
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        } finally {
            setIsClicked(false)
        }
    };

    const handleStep5 = async () => {
        try {

            // --- volunteer Validation ---
            if (!volunteer.trim()) return setVolunteerError("Please Select atleast one option...");

            // --- consent Validation ---
            if (!consent.trim()) return setConsentError("Please Select atleast one option...");

            // --- record Validation ---
            if (!record.trim()) return setRecordError("Please Select atleast one option...");

            // --- bio Validation ---
            if (!bio.trim()) return setBioError("Please Select atleast one option...");

            setIsClicked(true)

            // --- API Call ---
            const { data } = await axios.post(API.BASE_URL + API.SPEAKER_SUBMIT, {
                email,
                voluntaryConsent: volunteer === "No" ? false : true,
                promoConsent: consent === "No" ? false : true,
                recordingConsent: record === "No" ? false : true,
                shortBio: bio === "No" ? false : true
            });

            if (data?.statusCode === 200) {
                handleSubmit()
            }
            handleSubmit()
        } catch (err) {
            toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
                position: "top-right",
                autoClose: 3000,
            });
        }
    };

    // const handleSubmitPayment = async () => {
    //     try {

    //         // --- API Call ---
    //         const { data } = await axios.post(API.BASE_URL + API.SPEAKER_UPDATE_PAYMENT, {
    //             email,
    //         });

    //         if (data?.statusCode === 200) {
    //             setIsSuccess(true);
    //         }
    //         setIsSuccess(true);
    //     } catch (err) {
    //         toast.error(err?.response?.data?.error || "Something went wrong. Please try again.", {
    //             position: "top-right",
    //             autoClose: 3000,
    //         });
    //     } finally {
    //         setIsClicked(false)
    //     }
    // };

    const loadScript = async (src) => {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;
            script.onload = resolve;
            document.body.appendChild(script);
        });
    }

    const handleSubmit = async () => {
        try {
            setIsClicked(true)
            const params = new URLSearchParams({
                name,
                email,
                number,
                location,

                linkedin,
                role,
                company,
                years,

                domainYears,
                teaching,
                interestedTrack,
                experience,

                tools,
                days,
                time,
                engagement,
                session,

                volunteer,
                consent,
                record,
                bio
            });
            const { data } = await axios.post(
                API.PAYMENT_BASE_URL + API.PAYMENT,
                {
                    userCount: 1, subscriptionType: "monthly", pageType: "surgeSpeaker", packageType: "", redirectLink: `${window.location.origin}/surge-speakers/payment-checking?${params.toString()}`,
                },
            );
            if (data === "nodomain") {
                alert("Domain url wrong");
                window.location.href = "/404";
            }
            else if (data?.statusCode === 200) {
                razorPayment(data?.data);
            }
        } catch (err) {
            var statusCode = err?.response?.status;
            console.log(statusCode);
            setIsClicked(false)
        }
    };

    const razorPayment = async (purchaseData) => {
        if (!scriptLoaded) {
            await loadScript('https://checkout.razorpay.com/v1/checkout.js'); // Load the Razorpay script dynamically
            setScriptLoaded(true);
        }

        const options = {
            key: API.KEY,
            description: "Surge Speaker",
            order_id: purchaseData?.id,
            callback_url: API.PAYMENT_BASE_URL + API.PAYMENT_SUCCESS,
            // handler: async (response) => {
            //     handleSubmitPayment()
            //     const res = await axios.post(API.PAYMENT_BASE_URL + API.PAYMENT_SUCCESS, {
            //         ...response,
            //     }, {
            //         headers: { "x-axios-request": "true" }
            //     });
            //     if (res.data.success) {
            //         // window.location.href = res.data.redirectUrl;
            //     }
            // },
            notes: {
                purchaseId: purchaseData?.id
            },
            prefill: {
                email: email,
                contact: number,
                // 'method': 'card' //netbanking|card|upi|wallet
            },
            modal: {
                ondismiss: async () => {
                    await axios.post(API.PAYMENT_BASE_URL + API.PAYMENT_CLOSED, { id: purchaseData?.id });
                    setIsPaymentFailed(true)
                    setIsSuccess(true)
                    setIsClicked(false)
                },
            },
            theme: {
                color: "#560095"
            },
            config: {
                display: {
                    hide: [
                        { method: 'paylater' },
                        { method: 'emi' },
                        { method: 'cardless_emi' },
                        // { method: 'upi' },
                    ],
                }
            }
        };

        const razorpay = new window.Razorpay(options);
        razorpay.open();
    };

    const tracks = [
        "Software Development Track",
        "UI/UX & Product Design Track",
        "QA & Testing Track",
        "Data Science & Analytics Track",
        "AI & Machine Learning Track",
        "Cybersecurity & Ethical Hacking Track",
        "Cloud & DevOps Track",
        "Product Management Track",
        "Digital Marketing & Growth Track",
        "Content Creation & Personal Branding Track",
        "Business & Entrepreneurship Track",
        "Mechanical Engineering Domain Track",
        "Civil Engineering Domain Track",
        "Electrical & Electronics (EEE) Domain Track",
        "Electronics & Communication (ECE) Domain Track",
        "Instrumentation & E&I Domain Track",
        "Chemical Engineering Domain Track",
        "Biotech & Life Sciences Domain Track",
        "Robotics & Mechatronics Track",
        "Architecture & Interior Design Track",
        "Arts & Humanities Career Track",
        "Science (Physics / Chemistry / Math) Career Track",
        "Commerce, Finance & Accounting Track",
        "Creator Economy & Influencer Track",
    ];

    useEffect(() => {
        if (isSuccess) {
            // reset timer every time popup opens
            setTimeLeft(30);

            timerRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    if (prev <= 1) {
                        clearInterval(timerRef.current);
                        if (isPaymentFailed) {
                            setIsSuccess(false);
                            setIsPaymentFailed(false);
                        } else {
                            window.location.href = "/surge-speakers"
                        }
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);
        }

        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSuccess]);

    return (
        <div className='p-[20px] md:p-[50px] h-screen flex flex-col gap-[30px]'>
            <div>
                <div className='flex justify-between gap-[14px]'>
                    <div>
                        <h1 className='text-[#080808] font-semibold text-[20px] md:text-[28px]'>Speakers Registration Form | Surge Speakers</h1>
                        <h2 className='mt-[7px] text-[16px] md:text-[22px] font-normal'>Fill out the form below to reserve your spot.</h2>
                    </div>
                    <LuX className='text-[20px] md:text-[24px] mt-[5px]' onClick={() => { window.location.href = "/surge-speakers" }} />
                </div>
                <div className="grid gap-[10px] py-[10px] grid-cols-5 mt-[10px] md:mt-[20px]">
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF3B30] transition-all duration-500 ease-in-out ${isStep1 ? "w-full rounded-full" : "w-1/2 rounded-l-full"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#FF9500] transition-all duration-500 ease-in-out ${isStep2 ? "w-full rounded-full" : isStep1 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#34C759] transition-all duration-500 ease-in-out ${isStep3 ? "w-full rounded-full" : isStep2 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#00C7BE] transition-all duration-500 ease-in-out ${isStep4 ? "w-full rounded-full" : isStep3 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                    <div className='w-full bg-[#AEAEB2] h-[6px] rounded-full transition-all'>
                        <div className={`h-full bg-[#00C7BE] transition-all duration-500 ease-in-out ${(isSuccess && !isPaymentFailed) ? "w-full rounded-full" : isStep4 ? "w-1/2 rounded-l-full" : "w-0"}`}></div>
                    </div>
                </div>
            </div>
            <div className={`flex justify-start items-center w-full overflow-hidden h-full`}>
                {/* ---- Step 1 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={nameIcon} alt='nameIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Full Name <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={name} placeholder='Enter your full name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setName(e.target.value); setNameError('') }} />
                        </div>
                        {nameError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{nameError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={emailIcon} alt='emailIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Email ID <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='email' value={email} placeholder='Enter your Email ID' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setEmail(e.target.value); setEmailError('') }} />
                        </div>
                        {emailError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{emailError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FFCC0026] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={phoneIcon} alt='phoneIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Phone No ( WhatsApp enabled) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[10px] md:rounded-[16px] px-[6px] md:px-[11px] py-[8px]'>
                            <PhoneInput defaultCountry="in" value={number} onChange={(phone, country) => { setNumber(phone); setCountryCode(country?.country); setNumberError(''); }}
                                countrySelector={{
                                    showSearch: true,
                                    searchPlaceholder: "Search country...",
                                }}
                                className="max-h-[40px] sm:max-h-[60px] h-full w-full focus:outline-none cursor-pointer surge-form placeholder:text-[#000]" />
                        </div>
                        {numberError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{numberError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#007AFF33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={locationIcon} alt='locationIcon' className='w-[7px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>City & Country <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={location} placeholder='Enter your City and Country' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setLocation(e.target.value); setLocationError('') }} />
                        </div>
                        {locationError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{locationError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 2 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-1 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#30fff133] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[12px] md:text-[18px] text-[#46b1aa]'>
                                <FaLinkedin />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Your LinkedIn Profile.<span className='text-[#FFDD09]'>* </span> </div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={linkedin} placeholder='Enter your linkedin profile' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setLinkdin(e.target.value); setLinkdinError("") }} />
                        </div>
                        {linkdinError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{linkdinError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#00C7BE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={graduationIcon} alt='graduationIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Current Role / Designation <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={role} placeholder='Enter the Current Role / Designation' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setRole(e.target.value); setRoleError('') }} />
                        </div>
                        {roleError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{roleError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#30B0C733] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={collegeIcon} alt='collegeIcon' className='w-[10px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Current Organization / Company <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={company} placeholder='Enter company name' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setCompany(e.target.value); setCompanyError('') }} />
                        </div>
                        {companyError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{companyError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={yearIcon} alt='yearIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Total Years of Industry Experience <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='number' min={0} value={years} placeholder='Enter your total years of Industry Experience' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setYears(e.target.value); setYearsError('') }} />
                        </div>
                        {yearsError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{yearsError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 3 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep3 ? "opacity-0 -translate-x-[300%]" : isStep2 ? "opacity-1 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#5856D633] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={domainYearsIcon} alt='domainYearsIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Relevant Experience in Domain (Years) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={domainYears} placeholder='Ex. 1 / 2 / 3 ...' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setDomainYears(e.target.value); setDomainYearsError('') }} />
                        </div>
                        {domainYearsError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{domainYearsError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#AF52DE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={teachingIcon} alt='teachingIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Previous Mentoring / Teaching Experience <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${teaching === "Yes, I agree" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (teaching === "Yes, I agree") { setTeaching(""); } else { setTeaching("Yes, I agree"); setTeachingError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${teaching === "Yes, I agree" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Yes</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${teaching === "No" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (teaching === "No") { setTeaching(""); } else { setTeaching("No"); setTeachingError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${teaching === "No" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>No</h3>
                            </div>
                        </div>
                        {teachingError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{teachingError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF2D5533] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={interestIcon} alt='interestIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Primary Domain Expertise <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px] md:h-[150px] overflow-y-scroll'>
                            {tracks.map((track, index) => (
                                <div key={index} className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${interestedTrack === track ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`}
                                    onClick={() => {
                                        if (interestedTrack === track) {
                                            setInterestedTrack("");
                                        } else {
                                            setInterestedTrack(track);
                                            setInterestedTrackError("");
                                        }
                                    }}
                                >
                                    <div
                                        className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${interestedTrack === track ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`} >
                                        <span className="font-bold">
                                            {String.fromCharCode(65 + index)}
                                        </span>
                                    </div>
                                    <h3 className="w-full text-start break-word text-[12px] sm:text-[18px]">
                                        {track}
                                    </h3>
                                </div>
                            ))}

                        </div>
                        {interestedTrackError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{interestedTrackError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#A2845E33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={experienceIcon} alt='experienceIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Expertise Level <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${experience === "Practitioner" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (experience === "Practitioner") { setExperience(""); } else { setExperience("Practitioner"); setExperienceError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${experience === "Practitioner" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Practitioner</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${experience === "Senior Practitioner" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (experience === "Senior Practitioner") { setExperience(""); } else { setExperience("Senior Practitioner"); setExperienceError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${experience === "Senior Practitioner" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Senior Practitioner</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${experience === "Subject Matter Expert" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (experience === "Subject Matter Expert") { setExperience(""); } else { setExperience("Subject Matter Expert"); setExperienceError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${experience === "Subject Matter Expert" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Subject Matter Expert</h3>
                            </div>
                        </div>
                        {experienceError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{experienceError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 4 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep4 ? "opacity-0 -translate-x-[400%]" : isStep3 ? "opacity-1 -translate-x-[300%]" : isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#32ADE633] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={universityIcon} alt='universityIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Tools / Technologies / Skill Areas <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[10px] w-full border border-[#E8E8E8] rounded-[6px] md:rounded-[16px] px-[6px] py-[5px] md:px-[11px] md:py-[10px]'>
                            <input type='text' value={tools} placeholder='Ex: VS Code, FIgma, React, AWS' className='max-w-full w-full bg-transparent text-[15px] md:text-[18px] focus:outline-none focus:shadow-focus shadow-focus cursor-pointer placeholder:text-[#000]' onChange={(e) => { setTools(e.target.value); setToolsError('') }} />
                        </div>
                        {toolsError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{toolsError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF3B3033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={daysIcon} alt='daysIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Preferred Days <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${days === "Saturday" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (days === "Saturday") { setDays(""); } else { setDays("Saturday"); setDaysError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${days === "Saturday" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Saturday</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${days === "Sunday" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (days === "Sunday") { setDays(""); } else { setDays("Sunday"); setDaysError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${days === "Sunday" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Sunday</h3>
                            </div>
                        </div>
                        {daysError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{daysError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#34C759]'>
                                <GoClockFill className='size-[15px] md:size-[20px]' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Preferred Timing <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${time === "Morning" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (time === "Morning") { setTime(""); } else { setTime("Morning"); setTimeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${time === "Morning" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Morning</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${time === "Afternoon" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (time === "Afternoon") { setTime(""); } else { setTime("Afternoon"); setTimeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${time === "Afternoon" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Afternoon</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${time === "Evening" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (time === "Evening") { setTime(""); } else { setTime("Evening"); setTimeError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${time === "Evening" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Evening</h3>
                            </div>
                        </div>
                        {timeError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{timeError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={engagementIcon} alt='engagementIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Frequency of Engagement<span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${engagement === "Weekly" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (engagement === "Weekly") { setEngagement(""); } else { setEngagement("Weekly"); setEngagementError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${engagement === "Weekly" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Weekly</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${engagement === "Bi-weekly" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (engagement === "Bi-weekly") { setEngagement(""); } else { setEngagement("Bi-weekly"); setEngagementError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${engagement === "Bi-weekly" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Bi-weekly</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${engagement === "Monthly" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (engagement === "Monthly") { setEngagement(""); } else { setEngagement("Monthly"); setEngagementError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${engagement === "Monthly" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Monthly</h3>
                            </div>
                        </div>
                        {engagementError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{engagementError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#007AFF33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={sessionIcon} alt='sessionIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Duration Willing to Commit <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "1 month" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "1 month") { setSession(""); } else { setSession("1 month"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "1 month" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>1 month</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "3 months" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "3 months") { setSession(""); } else { setSession("3 months"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "3 months" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>3 months</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "6 months" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "6 months") { setSession(""); } else { setSession("6 months"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "6 months" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>C</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>6 months</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${session === "Continuous" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (session === "Continuous") { setSession(""); } else { setSession("Continuous"); setSessionError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${session === "Continuous" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>D</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Continuous</h3>
                            </div>
                        </div>
                        {sessionError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{sessionError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
                {/* ---- Step 5 ---- */}
                <div className={`flex flex-col md:grid lg:grid-cols-2 gap-[30px] lg:gap-[60px] w-10/12 mx-auto min-w-full transition-all ease-in-out duration-500 h-full lg:h-max overflow-y-scroll ${isStep4 ? "opacity-1 -translate-x-[400%]" : isStep3 ? "opacity-1 -translate-x-[300%]" : isStep2 ? "opacity-0 -translate-x-[200%]" : isStep1 ? "opacity-0 -translate-x-[100%]" : ""}`}>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#007AFF33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#007AFF]'>
                                <MdVolunteerActivism className='size-[15px] md:size-[20px]' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Volunteering Nature, I confirm this is a voluntary, unpaid engagement <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${volunteer === "Yes, I am aware" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (volunteer === "Yes, I am aware") { setVolunteer(""); } else { setVolunteer("Yes, I agree"); setVolunteerError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${volunteer === "Yes, I am aware" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Yes, I am aware</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${volunteer === "No" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (volunteer === "No") { setVolunteer(""); } else { setVolunteer("No"); setVolunteerError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${volunteer === "No" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>No</h3>
                            </div>
                        </div>
                        {volunteerError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{volunteerError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#34C75933] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0'>
                                <img src={consentIcon} alt='consentIcon' className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Consent to: Use name, designation, company name for program promotion <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${consent === "Yes" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (consent === "Yes") { setConsent(""); } else { setConsent("Yes"); setConsentError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${consent === "Yes" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Yes</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${consent === "No" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (consent === "No") { setConsent(""); } else { setConsent("No"); setConsentError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${consent === "No" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>No</h3>
                            </div>
                        </div>
                        {consentError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{consentError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#FF950033] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#FF9500]'>
                                <MdVideocam className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Record sessions for student learning (internal use) <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${record === "Yes" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (record === "Yes") { setRecord(""); } else { setRecord("Yes"); setRecordError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${record === "Yes" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Yes</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${record === "No" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (record === "No") { setRecord(""); } else { setRecord("No"); setRecordError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${record === "No" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>No</h3>
                            </div>
                        </div>
                        {recordError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{recordError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                    <div className='h-max'>
                        <div className='flex gap-[10px] items-center'>
                            <div className='bg-[#00C7BE33] size-[28px] md:size-[38px] rounded-[6px] md:rounded-[10px] flex justify-center items-center shrink-0 text-[#00C7BE]'>
                                <MdAutoFixHigh className='w-[15px] md:w-auto' />
                            </div>
                            <div className='text-[#080808] text-[14px] md:text-[18px] font-medium'>Short Bio <span className='text-[#FF2D55]'>* </span></div>
                        </div>
                        <div className='mt-[20px] w-full flex flex-wrap gap-[10px] md:gap-[20px]'>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${bio === "Yes" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (bio === "Yes") { setBio(""); } else { setBio("Yes"); setBioError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${bio === "Yes" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>A</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>Yes</h3>
                            </div>
                            <div className={`relative flex gap-[5px] md:gap-[10px] items-center font-semibold rounded-[4px] p-[5px] md:p-[10px] break-words cursor-pointer shadow-radio ${bio === "No" ? "border-[1px] border-[#000] bg-[#e6e6e6] text-[#0d0601]" : "bg-[#0d0601] text-[#e6e6e6] hover:bg-[#474747]"}`} onClick={() => { if (bio === "No") { setBio(""); } else { setBio("No"); setBioError('') } }}>
                                <div className={`size-[14px] md:w-6 md:h-6 min-h-[12px] md:min-h-[22px] shrink-0 rounded-[2px] text-[8px] md:text-xs border-[1px] flex justify-center items-center ${bio === "No" ? "bg-[#e6e6e6] text-[#0d0601] border-[#000]" : "bg-[#0d0601] text-[#e6e6e6] border-[#e6e6e6]"}`}>
                                    <span className='font-bold'>B</span>
                                </div>
                                <h3 className='w-full text-start break-word text-[12px] sm:text-[18px]'>No</h3>
                            </div>
                        </div>
                        {bioError && (
                            <div className='mt-[8px] md:mt-[16px] w-full flex gap-2 md:gap-4 items-center'>
                                <div className='bg-[#f7e6e6] md:min-h-7 rounded-[3px] flex gap-1 items-center justify-center py-1.5 pl-2 pr-3'>
                                    <LuTriangleAlert className='text-[#af0404] text-[12px] md:text-sm' />
                                    <h3 className='text-[#af0404] text-[12px] md:text-sm'>{bioError}</h3>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div className='flex gap-[10px] md:gap-[20px] items-center justify-center flex-wrap'>
                <button disabled={!isStep1} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] border border-[#54545657] text-[#3C3C4399] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        if (isStep4) {
                            setIsStep4(false)
                        } else if (isStep3) {
                            setIsStep3(false)
                        } else if (isStep2) {
                            setIsStep2(false)
                        } else if (isStep1) {
                            setIsStep1(false)
                        }
                    }}>Back</button>
                <button disabled={isClicked} className='w-full md:w-[390px] h-[40px] md:h-[70px] rounded-[12px] md:rounded-[18px] bg-[#34C759] text-[#FFFFFF] font-semibold text-[20px] md:text-[25px]'
                    onClick={() => {
                        if (!isStep1) {
                            handleStep1()
                        } else if (!isStep2) {
                            handleStep2()
                        } else if (!isStep3) {
                            handleStep3()
                        } else if (!isStep4) {
                            handleStep4()
                        } else if (isStep4) {
                            handleStep5()
                        }
                    }}>Next</button>
            </div>
            {isSuccess && (
                <div className="bg-[#000]/[70%] fixed inset-0 z-[100] h-screen w-full flex justify-center items-center">
                    <div className='bg-[#FFF] w-11/12 md:w-1/2 max-h-[80vh] rounded-[14px] p-[20px] relative text-center'>
                        <LuX className='text-[16px] md:text-[22px] cursor-pointer absolute top-[20px] right-[20px]'
                            onClick={() => {
                                if (isPaymentFailed) {
                                    setIsPaymentFailed(false);
                                    setIsSuccess(false);
                                    setTimeLeft(30);
                                    if (timerRef.current) {
                                        clearInterval(timerRef.current);
                                        timerRef.current = null;
                                    }
                                } else {
                                    window.location.href = "/surge-speakers"
                                }
                            }} />
                        <div className='font-medium text-[16px] md:text-[22px]'>
                            <p className='text-[#414141] text-center'>Automatically closing in</p>
                            <div className='size-[40px] md:size-[50px] mx-auto mt-[4px] md:mt-[7px] rounded-full border-[2px] border-[#34C759] flex justify-center items-center text-[#34C759]'>{timeLeft}</div>
                        </div>
                        <div className='mt-[12px] md:mt-[24px]'>
                            <div className='size-[80px] md:size-[120px] mx-auto flex justify-center items-center'>
                                <LoadLottie animationData={isPaymentFailed ? Error : Tick} loop={true} />
                            </div>
                            <p className='text-[20px] md:text-[25px] mt-[4px] font-semibold text-[#000000]'>{isPaymentFailed ? "Payment Failed. Please try again." : "Congratulations your slot is booked successfully"}</p>
                            <p className='text-[16px] md:text-[22px] mt-[4px] font-medium text-[#828487]'>{isPaymentFailed ? "Your slot wasn’t booked. If money was deducted, it’ll be refunded shortly." : "We sent the details in registered email."}</p>
                        </div>
                        <button className={`mt-[12px] md:mt-[24px] w-full h-[45px] md:h-[72px] rounded-[12px] md:rounded-[18px] text-[16px] md:text-[25px] font-semibold ${isPaymentFailed ? "bg-[#FFDD09] text-[#000000]" : "bg-[#34C759] text-[#F3F3F3]"}`}
                            onClick={() => {
                                if (isPaymentFailed) {
                                    setIsPaymentFailed(false);
                                    setIsSuccess(false);
                                    setTimeLeft(30);
                                    if (timerRef.current) {
                                        clearInterval(timerRef.current);
                                        timerRef.current = null;
                                    }
                                } else {
                                    window.location.href = "/surge-speakers"
                                }
                            }}>{isPaymentFailed ? "Try Again " : "Back to Home"}</button>
                    </div>
                </div>
            )}
        </div>
    )
}
